// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type MaterialAssemblyForm_AssemblyComponentsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type MaterialAssemblyForm_AssemblyComponentsQuery = { __typename?: 'Query', materialVariant: { __typename?: 'MaterialVariant', id: string, components: Array<{ __typename?: 'MaterialAssemblyComponent', id: string, name?: string | null | undefined, qualifier?: string | null | undefined, component: { __typename?: 'MaterialVariant', id: string, displayName: string, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, useInTakeoff: boolean } }>, listing: { __typename?: 'MaterialListing', id: string, type: { __typename?: 'MaterialTypeDetail', code: Types.MaterialType, name: string }, item: { __typename?: 'Item', id: string, name: string, materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string, name: string, useInTakeoff: boolean, type: { __typename?: 'MaterialAttributeDimensionTypeDetail', code: Types.MaterialAttributeDimensionType }, values: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string }> }> } } } }> } };

export type MaterialAssemblyForm_MaterialVariantsQueryVariables = Types.Exact<{
  filter: Types.MaterialVariantsFilter;
  page?: Types.InputMaybe<Types.PageFilter>;
}>;


export type MaterialAssemblyForm_MaterialVariantsQuery = { __typename?: 'Query', materialVariants: { __typename?: 'MaterialVariantsPage', entities: Array<{ __typename?: 'MaterialVariant', id: string, displayName: string, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, useInTakeoff: boolean } }>, listing: { __typename?: 'MaterialListing', id: string, type: { __typename?: 'MaterialTypeDetail', code: Types.MaterialType, name: string }, item: { __typename?: 'Item', id: string, name: string, materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string, name: string, useInTakeoff: boolean, type: { __typename?: 'MaterialAttributeDimensionTypeDetail', code: Types.MaterialAttributeDimensionType }, values: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string }> }> } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, nextPage?: { __typename?: 'Page', limit: number, offset: number } | null | undefined } } };

export type MaterialAssemblyForm_ItemsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MaterialAssemblyForm_ItemsQuery = { __typename?: 'Query', items: Array<{ __typename?: 'Item', id: string, name: string, materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string, name: string, useInTakeoff: boolean, type: { __typename?: 'MaterialAttributeDimensionTypeDetail', code: Types.MaterialAttributeDimensionType }, values: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string }> }> }> };

export type MaterialAssemblyForm_MvPageInfoFragment = { __typename?: 'PageInfo', hasNextPage: boolean, nextPage?: { __typename?: 'Page', limit: number, offset: number } | null | undefined };

export type MaterialAssemblyForm_AssemblyComponentFragment = { __typename?: 'MaterialAssemblyComponent', id: string, name?: string | null | undefined, qualifier?: string | null | undefined, component: { __typename?: 'MaterialVariant', id: string, displayName: string, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, useInTakeoff: boolean } }>, listing: { __typename?: 'MaterialListing', id: string, type: { __typename?: 'MaterialTypeDetail', code: Types.MaterialType, name: string }, item: { __typename?: 'Item', id: string, name: string, materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string, name: string, useInTakeoff: boolean, type: { __typename?: 'MaterialAttributeDimensionTypeDetail', code: Types.MaterialAttributeDimensionType }, values: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string }> }> } } } };

export type MaterialAssemblyForm_MaterialVariantFragment = { __typename?: 'MaterialVariant', id: string, displayName: string, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, useInTakeoff: boolean } }>, listing: { __typename?: 'MaterialListing', id: string, type: { __typename?: 'MaterialTypeDetail', code: Types.MaterialType, name: string }, item: { __typename?: 'Item', id: string, name: string, materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string, name: string, useInTakeoff: boolean, type: { __typename?: 'MaterialAttributeDimensionTypeDetail', code: Types.MaterialAttributeDimensionType }, values: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string }> }> } } };

export type MaterialAssemblyForm_ItemFragment = { __typename?: 'Item', id: string, name: string, materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string, name: string, useInTakeoff: boolean, type: { __typename?: 'MaterialAttributeDimensionTypeDetail', code: Types.MaterialAttributeDimensionType }, values: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string }> }> };

export type MaterialAssemblyForm_MaterialAttributeDimensionFragment = { __typename?: 'MaterialAttributeDimension', id: string, name: string, useInTakeoff: boolean, type: { __typename?: 'MaterialAttributeDimensionTypeDetail', code: Types.MaterialAttributeDimensionType }, values: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string }> };

export const MaterialAssemblyForm_MvPageInfoFragmentDoc = gql`
    fragment MaterialAssemblyForm_MVPageInfo on PageInfo {
  hasNextPage
  nextPage {
    limit
    offset
  }
}
    `;
export const MaterialAssemblyForm_MaterialAttributeDimensionFragmentDoc = gql`
    fragment MaterialAssemblyForm_MaterialAttributeDimension on MaterialAttributeDimension {
  id
  name
  useInTakeoff
  type {
    code
  }
  values {
    id
    textValue
  }
}
    `;
export const MaterialAssemblyForm_ItemFragmentDoc = gql`
    fragment MaterialAssemblyForm_Item on Item {
  id
  name
  materialAttributeDimensions {
    ...MaterialAssemblyForm_MaterialAttributeDimension
  }
}
    ${MaterialAssemblyForm_MaterialAttributeDimensionFragmentDoc}`;
export const MaterialAssemblyForm_MaterialVariantFragmentDoc = gql`
    fragment MaterialAssemblyForm_MaterialVariant on MaterialVariant {
  id
  displayName
  materialAttributeValues {
    id
    textValue
    dimension {
      id
      useInTakeoff
    }
  }
  listing {
    id
    type {
      code
      name
    }
    item {
      ...MaterialAssemblyForm_Item
    }
  }
}
    ${MaterialAssemblyForm_ItemFragmentDoc}`;
export const MaterialAssemblyForm_AssemblyComponentFragmentDoc = gql`
    fragment MaterialAssemblyForm_AssemblyComponent on MaterialAssemblyComponent {
  id
  name
  qualifier
  component {
    ...MaterialAssemblyForm_MaterialVariant
  }
}
    ${MaterialAssemblyForm_MaterialVariantFragmentDoc}`;
export const MaterialAssemblyForm_AssemblyComponentsDocument = gql`
    query MaterialAssemblyForm_AssemblyComponents($id: ID!) {
  materialVariant(id: $id) {
    id
    components {
      ...MaterialAssemblyForm_AssemblyComponent
    }
  }
}
    ${MaterialAssemblyForm_AssemblyComponentFragmentDoc}`;

/**
 * __useMaterialAssemblyForm_AssemblyComponentsQuery__
 *
 * To run a query within a React component, call `useMaterialAssemblyForm_AssemblyComponentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialAssemblyForm_AssemblyComponentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialAssemblyForm_AssemblyComponentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMaterialAssemblyForm_AssemblyComponentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MaterialAssemblyForm_AssemblyComponentsQuery, MaterialAssemblyForm_AssemblyComponentsQueryVariables> & ({ variables: MaterialAssemblyForm_AssemblyComponentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MaterialAssemblyForm_AssemblyComponentsQuery, MaterialAssemblyForm_AssemblyComponentsQueryVariables>(MaterialAssemblyForm_AssemblyComponentsDocument, options);
      }
export function useMaterialAssemblyForm_AssemblyComponentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MaterialAssemblyForm_AssemblyComponentsQuery, MaterialAssemblyForm_AssemblyComponentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MaterialAssemblyForm_AssemblyComponentsQuery, MaterialAssemblyForm_AssemblyComponentsQueryVariables>(MaterialAssemblyForm_AssemblyComponentsDocument, options);
        }
export function useMaterialAssemblyForm_AssemblyComponentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MaterialAssemblyForm_AssemblyComponentsQuery, MaterialAssemblyForm_AssemblyComponentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MaterialAssemblyForm_AssemblyComponentsQuery, MaterialAssemblyForm_AssemblyComponentsQueryVariables>(MaterialAssemblyForm_AssemblyComponentsDocument, options);
        }
export type MaterialAssemblyForm_AssemblyComponentsQueryHookResult = ReturnType<typeof useMaterialAssemblyForm_AssemblyComponentsQuery>;
export type MaterialAssemblyForm_AssemblyComponentsLazyQueryHookResult = ReturnType<typeof useMaterialAssemblyForm_AssemblyComponentsLazyQuery>;
export type MaterialAssemblyForm_AssemblyComponentsSuspenseQueryHookResult = ReturnType<typeof useMaterialAssemblyForm_AssemblyComponentsSuspenseQuery>;
export type MaterialAssemblyForm_AssemblyComponentsQueryResult = Apollo.QueryResult<MaterialAssemblyForm_AssemblyComponentsQuery, MaterialAssemblyForm_AssemblyComponentsQueryVariables>;
export const MaterialAssemblyForm_MaterialVariantsDocument = gql`
    query MaterialAssemblyForm_MaterialVariants($filter: MaterialVariantsFilter!, $page: PageFilter) {
  materialVariants(filter: $filter, page: $page) {
    entities {
      ...MaterialAssemblyForm_MaterialVariant
    }
    pageInfo {
      ...MaterialAssemblyForm_MVPageInfo
    }
  }
}
    ${MaterialAssemblyForm_MaterialVariantFragmentDoc}
${MaterialAssemblyForm_MvPageInfoFragmentDoc}`;

/**
 * __useMaterialAssemblyForm_MaterialVariantsQuery__
 *
 * To run a query within a React component, call `useMaterialAssemblyForm_MaterialVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialAssemblyForm_MaterialVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialAssemblyForm_MaterialVariantsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useMaterialAssemblyForm_MaterialVariantsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MaterialAssemblyForm_MaterialVariantsQuery, MaterialAssemblyForm_MaterialVariantsQueryVariables> & ({ variables: MaterialAssemblyForm_MaterialVariantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MaterialAssemblyForm_MaterialVariantsQuery, MaterialAssemblyForm_MaterialVariantsQueryVariables>(MaterialAssemblyForm_MaterialVariantsDocument, options);
      }
export function useMaterialAssemblyForm_MaterialVariantsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MaterialAssemblyForm_MaterialVariantsQuery, MaterialAssemblyForm_MaterialVariantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MaterialAssemblyForm_MaterialVariantsQuery, MaterialAssemblyForm_MaterialVariantsQueryVariables>(MaterialAssemblyForm_MaterialVariantsDocument, options);
        }
export function useMaterialAssemblyForm_MaterialVariantsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MaterialAssemblyForm_MaterialVariantsQuery, MaterialAssemblyForm_MaterialVariantsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MaterialAssemblyForm_MaterialVariantsQuery, MaterialAssemblyForm_MaterialVariantsQueryVariables>(MaterialAssemblyForm_MaterialVariantsDocument, options);
        }
export type MaterialAssemblyForm_MaterialVariantsQueryHookResult = ReturnType<typeof useMaterialAssemblyForm_MaterialVariantsQuery>;
export type MaterialAssemblyForm_MaterialVariantsLazyQueryHookResult = ReturnType<typeof useMaterialAssemblyForm_MaterialVariantsLazyQuery>;
export type MaterialAssemblyForm_MaterialVariantsSuspenseQueryHookResult = ReturnType<typeof useMaterialAssemblyForm_MaterialVariantsSuspenseQuery>;
export type MaterialAssemblyForm_MaterialVariantsQueryResult = Apollo.QueryResult<MaterialAssemblyForm_MaterialVariantsQuery, MaterialAssemblyForm_MaterialVariantsQueryVariables>;
export const MaterialAssemblyForm_ItemsDocument = gql`
    query MaterialAssemblyForm_Items {
  items(filter: {version: [2]}) {
    ...MaterialAssemblyForm_Item
  }
}
    ${MaterialAssemblyForm_ItemFragmentDoc}`;

/**
 * __useMaterialAssemblyForm_ItemsQuery__
 *
 * To run a query within a React component, call `useMaterialAssemblyForm_ItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialAssemblyForm_ItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialAssemblyForm_ItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMaterialAssemblyForm_ItemsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MaterialAssemblyForm_ItemsQuery, MaterialAssemblyForm_ItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MaterialAssemblyForm_ItemsQuery, MaterialAssemblyForm_ItemsQueryVariables>(MaterialAssemblyForm_ItemsDocument, options);
      }
export function useMaterialAssemblyForm_ItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MaterialAssemblyForm_ItemsQuery, MaterialAssemblyForm_ItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MaterialAssemblyForm_ItemsQuery, MaterialAssemblyForm_ItemsQueryVariables>(MaterialAssemblyForm_ItemsDocument, options);
        }
export function useMaterialAssemblyForm_ItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MaterialAssemblyForm_ItemsQuery, MaterialAssemblyForm_ItemsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MaterialAssemblyForm_ItemsQuery, MaterialAssemblyForm_ItemsQueryVariables>(MaterialAssemblyForm_ItemsDocument, options);
        }
export type MaterialAssemblyForm_ItemsQueryHookResult = ReturnType<typeof useMaterialAssemblyForm_ItemsQuery>;
export type MaterialAssemblyForm_ItemsLazyQueryHookResult = ReturnType<typeof useMaterialAssemblyForm_ItemsLazyQuery>;
export type MaterialAssemblyForm_ItemsSuspenseQueryHookResult = ReturnType<typeof useMaterialAssemblyForm_ItemsSuspenseQuery>;
export type MaterialAssemblyForm_ItemsQueryResult = Apollo.QueryResult<MaterialAssemblyForm_ItemsQuery, MaterialAssemblyForm_ItemsQueryVariables>;